import { render, staticRenderFns } from "./principalMailBox.vue?vue&type=template&id=f0949562&"
import script from "./principalMailBox.vue?vue&type=script&lang=js&"
export * from "./principalMailBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports